import cache from "./lib/config/cache";
import baseService from "./lib/config/service";
import {proInterceptors, devInterceptors} from "./lib/util/https";
import defaultsDeep from 'lodash.defaultsdeep';
import {defaultsTemplate, proTemplate, devTemplate} from './lib/util/options';
import routes from './lib/routes';
import authGuard from './lib/authGuard';

import appMain from './lib/components/app-main'
import sideMenu from './lib/components/side-menu'
import topHeader from './lib/components/top-header'

export {
    cache,
    baseService,
    initialAuth, 

    appMain,
    sideMenu,
    topHeader
}

function initialAuth (options = {}) {
    if (!options.router || !options.router.hasOwnProperty('matcher') || !options['x-app-code']) {
        throw new Error("router is not undefined");
    }

    options.router.addRoutes(routes);

    let projectOptions = defaultsDeep(options, defaultsTemplate);

    if (process.env.NODE_ENV === 'production') {

        if (!options.hasOwnProperty('x-app-code') || !options['x-app-code']) {
            throw new Error("x-app-code is not undefined");
        }

        proInterceptors();

        cache.setObject(projectOptions, proTemplate);

        options.router.beforeEach((to, from, next) => {

            // 不需要登陆or已经登陆过了
            if (to.meta.requireAuth || cache.requireAuth) {
                next();
                return;
            }
            authGuard(options, next);
        })
    }
    if (process.env.NODE_ENV === 'development') {

        devInterceptors();

        cache.setObject(projectOptions, devTemplate);

        options.router.beforeEach((to, from, next) => {
            
            // 不需要登陆or已经登陆过了
            if (to.meta.requireAuth || cache.requireAuth) {
                next();
                return;
            }
            cache.set('requireAuth', true);
            if (options.callback) {
                options.callback(next);
            }
            else {
                next()
            }
        })

    }
}